import React, { useCallback, useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { withRouter } from "react-router-dom";
import RoutesAuth from "./RoutesAuth";
import { Provider } from "react-redux";
import configureStore from "./store";
import { resetStore } from "./actions";

const store = configureStore();

const App = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [accessKey, setAccessKey] = useState(() => localStorage.getItem("access_key"));

  const userHasAuthenticated = useCallback((authenticated) => {
    setIsAuthenticated(authenticated);
  }, []);

  const handleLogout = useCallback(async () => {
    await Auth.signOut();
    window.localStorage.clear();
    setAccessKey(null);
    store.dispatch(resetStore());
    userHasAuthenticated(false);
    props.history.push("/signin");
  }, [props.history, userHasAuthenticated]);

  useEffect(() => {
    let isMounted = true;

    const refreshSession = async () => {
      try {
        setIsAuthenticated(true);
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
          if (!isMounted) {
            return;
          }
          if (err) {
            userHasAuthenticated(false);
            console.log("Unable to refresh Token:", err);
            return;
          }
          userHasAuthenticated(true);
          localStorage.setItem("idToken", session.idToken.jwtToken);
          const sessionAccessKey = session.idToken.payload["custom:access_key"];
          if (sessionAccessKey) {
            localStorage.setItem("access_key", sessionAccessKey);
            setAccessKey(sessionAccessKey);
          }
          if (
            session.idToken.payload["cognito:groups"] &&
            session.idToken.payload["cognito:groups"].includes("dea_admin")
          ) {
            localStorage.setItem("dea_role", "admin");
          }
        });
      } catch (e) {
        if (isMounted) {
          userHasAuthenticated(false);
          setAccessKey(null);
          console.log("Unable to refresh Token:", e);
        }
      } finally {
        if (isMounted) {
          setIsAuthenticating(false);
        }
      }
    };

    refreshSession();

    return () => {
      isMounted = false;
    };
  }, [userHasAuthenticated]);

  const childProps = {
    isAuthenticated,
    isAuthenticating,
    userHasAuthenticated,
    handleLogout,
    accessKey,
  };

  if (isAuthenticating) {
    return null;
  }

  return (
    <Provider store={store}>
      <div className="App">
        <RoutesAuth childProps={childProps} />
      </div>
    </Provider>
  );
};

export default withRouter(App);
